import { useRef } from 'react'
import css from './OtpInput.module.css'

interface OtpInputProps {
    value: string
    onChange: (value: string) => void
    error?: boolean
    disabled?: boolean
}

const OtpInput = ({ value, onChange, error = false, disabled = false }: OtpInputProps) => {
    const inputsRef = useRef<(HTMLInputElement | null)[]>([])
    const digits = value.padEnd(6, '').split('').slice(0, 6)

    const handleChange = (index: number, e: React.ChangeEvent<HTMLInputElement>) => {
        const char = e.target.value.replace(/\D/g, '').slice(-1)
        const next = digits.slice()
        next[index] = char
        const newValue = next.join('').slice(0, 6)
        onChange(newValue)
        if (char && index < 5) {
            inputsRef.current[index + 1]?.focus()
        }
    }

    const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Backspace') {
            if (digits[index]) {
                const next = digits.slice()
                next[index] = ''
                onChange(next.join(''))
            } else if (index > 0) {
                inputsRef.current[index - 1]?.focus()
            }
        } else if (e.key === 'ArrowLeft' && index > 0) {
            inputsRef.current[index - 1]?.focus()
        } else if (e.key === 'ArrowRight' && index < 5) {
            inputsRef.current[index + 1]?.focus()
        }
    }

    const handlePaste = (e: React.ClipboardEvent) => {
        const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
        if (pasted) {
            onChange(pasted)
            const focusIndex = Math.min(pasted.length, 5)
            inputsRef.current[focusIndex]?.focus()
        }
        e.preventDefault()
    }

    return (
        <div className={css.container}>
            {Array.from({ length: 6 }, (_, i) => (
                <input
                    key={i}
                    ref={el => { inputsRef.current[i] = el }}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    autoComplete={i === 0 ? 'one-time-code' : 'off'}
                    value={digits[i] || ''}
                    onChange={e => handleChange(i, e)}
                    onKeyDown={e => handleKeyDown(i, e)}
                    onPaste={handlePaste}
                    disabled={disabled}
                    className={`${css.box}${error ? ` ${css.error}` : ''}`}
                />
            ))}
        </div>
    )
}

export default OtpInput
